import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaSalidaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. SALIDA' htmlFor='date-fechaSalida' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaSalida'>
          {({ field }) => <Form.InputDate {...field} id='date-fechaSalida' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaSalidaFormGroup)
